module.exports = __webpack_public_path__ + "img/footer.43039e5c.jpg";